module.exports = __webpack_public_path__ + "static/media/review-logo.213fa53b.svg";